<template>
	<div class="tool-bar">
		<slot></slot>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'

	export default {
		name: 'ToolBar',
		methods: {
			...mapActions('system', ['ToggleToolBar']),
		},
		mounted() {
			this.ToggleToolBar(true)
		},
		beforeDestroy() {
			this.ToggleToolBar(false)
		},
	}
</script>

<style></style>
